var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(-89 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1159",
    "data-name": "Rectangle 1159",
    width: 77,
    height: 77,
    transform: "translate(89 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NFTAPIs",
    transform: "translate(97 4943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M15.166,45.458a14.083,14.083,0,0,1-6.361-26,17.335,17.335,0,0,1,34.39,0,14.083,14.083,0,0,1-6.362,26V45.5H15.166Z",
    transform: "translate(-2.159 -4.322)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M43,12.479A11.964,11.964,0,0,1,47.252,10a4.774,4.774,0,0,0,7.5,0A11.963,11.963,0,0,1,59,12.479a4.87,4.87,0,0,0,1.764,5.758,4.767,4.767,0,0,0,1.986.788,12.254,12.254,0,0,1,0,4.95,4.794,4.794,0,0,0-3.436,2.365A4.862,4.862,0,0,0,59,30.521,11.962,11.962,0,0,1,54.748,33a4.776,4.776,0,0,0-7.5,0A11.962,11.962,0,0,1,43,30.523a4.87,4.87,0,0,0-.314-4.182,4.787,4.787,0,0,0-3.435-2.364,12.256,12.256,0,0,1,0-4.951,4.768,4.768,0,0,0,1.985-.788A4.862,4.862,0,0,0,43,12.479Zm9.8,12.164a3.635,3.635,0,0,0,1.79-3.625,3.654,3.654,0,0,0-.452-1.347A3.58,3.58,0,0,0,49.2,18.354a3.64,3.64,0,0,0,.878,6.636,3.572,3.572,0,0,0,2.722-.348Z",
    transform: "translate(-2.159 -4.322)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M42.628,16.762a17.317,17.317,0,0,1,.566,2.7,14.084,14.084,0,0,1,6.644,11.867A4.8,4.8,0,0,0,47.252,33,11.964,11.964,0,0,1,43,30.523a4.87,4.87,0,0,0-.314-4.182,4.816,4.816,0,0,0-1.45-1.578,4.766,4.766,0,0,0-1.985-.786,12.256,12.256,0,0,1,0-4.951,4.768,4.768,0,0,0,1.985-.788,4.817,4.817,0,0,0,1.39-1.476Z",
    transform: "translate(-2.159 -4.322)",
    fill: "#004890",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreApi);
export default __webpack_public_path__ + "static/media/StoreApi.04929e27ebaa8d9a57ac79a1b39529f9.svg";
export { ForwardRef as ReactComponent };